 import { useEffect, useState } from "react";
import { Row, Col, Spin, Button, Typography, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import TourCard from "./TourCard";

const { Title } = Typography;

const ExploreTopMustDoThings = () => {
  const [toursPackage, setToursPackage] = useState([]);

  const [initialLoading, setInitialLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  const navigate = useNavigate();

  // =====================================================
  // GET SELECTED CITY
  // =====================================================

  const getSelectedCity = () => {
    const storedCity = localStorage.getItem("selectedCity");

    if (!storedCity) {
      return {
        id: 12,
        type: "city",
        name: "Dubai",
        slug: "dubai",
        countryName: "United Arab Emirates",
        countrySlug: "united-arab-emirates",
      };
    }

    try {
      const parsedCity = JSON.parse(storedCity);

      return parsedCity;
    } catch (error) {
      console.error("Invalid selectedCity:", error);

      return {
        id: 12,
        type: "city",
        name: "Dubai",
        slug: "dubai",
        countryName: "United Arab Emirates",
        countrySlug: "united-arab-emirates",
      };
    }
  };

  const selectedCity = getSelectedCity();

  const citySlug = selectedCity?.slug || "dubai";

  const cityName = selectedCity?.name || "Dubai";

  // =====================================================
  // FETCH TOURS
  // =====================================================

  const fetchTours = async (pageNumber = 1) => {
    try {
      if (pageNumber === 1) {
        setInitialLoading(true);
      } else {
        setLoading(true);
      }

      const pageSize = 4;

      const res = await axiosInstance.get("/product-details", {
        params: {
          // ==========================================
          // PRODUCT GROUP FILTER
          // ==========================================

          "filters[product_groups][name][$eq]":
            "Explore top must do things explore top",

          // ==========================================
          // CITY FILTER
          // ==========================================

          "filters[city][slug][$eq]": citySlug,

          // ==========================================
          // PAGINATION
          // ==========================================

          "pagination[page]": pageNumber,

          "pagination[pageSize]": pageSize,

          // ==========================================
          // IMAGES
          // ==========================================

          "populate[images][fields][0]": "url",

          // ==========================================
          // SUB PRODUCT
          // ==========================================

          "populate[sub_product][fields][0]": "slug",

          // ==========================================
          // CITY
          // ==========================================

          "populate[city][fields][0]": "name",

          "populate[city][fields][1]": "slug",
        },
      });

      const newData = res.data?.data || [];

      const pagination = res.data?.meta?.pagination;

      // ==========================================
      // UPDATE PRODUCTS
      // ==========================================

      setToursPackage((prev) => {
        if (pageNumber === 1) {
          return newData;
        }

        return [...prev, ...newData];
      });

      // ==========================================
      // UPDATE PAGINATION
      // ==========================================

      const totalPages = pagination?.pageCount || 1;

      setPage(pageNumber);

      setPageCount(totalPages);

      setHasMore(pageNumber < totalPages);

      // ==========================================
      // DEBUG
      // ==========================================

    } catch (error) {
      console.error("Error fetching tours:", error);

      if (pageNumber === 1) {
        setToursPackage([]);
      }
    } finally {
      setLoading(false);
      setInitialLoading(false);
    }
  };

  // =====================================================
  // INITIAL API CALL
  // =====================================================

  useEffect(() => {
    fetchTours(1);
  }, [citySlug]);

  // =====================================================
  // SEE MORE
  // =====================================================

  const handleSeeMore = () => {
    if (loading) return;

    if (!hasMore) return;

    const nextPage = page + 1;

    

    fetchTours(nextPage);
  };

  // =====================================================
  // INITIAL LOADING
  // =====================================================

  if (initialLoading) {
    return (
      <div className="flex justify-center py-10">
        <Spin size="large" tip="Loading Tours..." />
      </div>
    );
  }

  // =====================================================
  // UI
  // =====================================================

  return (
    <div className="container">

      {/* =================================================
          HEADER
      ================================================= */}

      <div className="flex justify-center items-center mb-8 font-medium">

        <Title
          className="!font-medium !text-danger !text-2xl !mb-1 text-center"
          level={2}
        >
          <span className="text-primary">
            Explore Top Must Do Things in{" "}
          </span>

          {cityName}
        </Title>

      </div>

      {/* =================================================
          TOURS GRID
      ================================================= */}

      <Row gutter={[16, 16]}>

        {toursPackage.length > 0 ? (

          toursPackage.map((tour) => {

            const title =
              tour.title ||
              tour.attributes?.title ||
              "Untitled Tour";

            // ============================================
            // IMAGE
            // ============================================

            const imageUrl =
              tour.images?.[0]?.url ||
              tour.attributes?.images?.data?.[0]?.attributes?.url ||
              "";

            // ============================================
            // TOUR DATA
            // ============================================

            const tourData = {
              ...tour,

              title,

              final_price:
                tour.final_price ?? 0,

              old_price:
                tour.old_price ?? 0,

              save_price:
                tour.save_price ?? 0,

              duration:
                tour.duration || "N/A",

              imageUrl: imageUrl
                ? `${process.env.REACT_APP_API_URL}${imageUrl}`
                : "",

              rating: 4.9,

              reviewCount: 523,
            };

            // ============================================
            // CARD CLICK
            // ============================================

            const handleClick = () => {

              const subSlug =
                tour.sub_product?.slug ||
                tour.attributes?.sub_product?.data?.attributes?.slug ||
                "subtour";

              const detailSlug =
                tour.slug ||
                tour.attributes?.slug ||
                "details";

              navigate(`/${subSlug}/${detailSlug}`);
            };

            return (
              <Col
                xs={24}
                md={12}
                key={tour.id}
              >
                <TourCard
                  tour={tourData}
                  onClick={handleClick}
                />
              </Col>
            );
          })

        ) : (

          <Col span={24}>

            <p className="text-center text-gray-500">
              No tours available in {cityName}.
            </p>

          </Col>

        )}

      </Row>

      {/* =================================================
          SEE MORE
      ================================================= */}

      {hasMore && (

        <Flex
          justify="center"
          className="mt-10"
        >

          <Button
            onClick={handleSeeMore}
            loading={loading}
            disabled={loading}
            className="font-semibold w-60 py-6 text-sm rounded-lg text-danger border-gray-400"
          >
            {loading ? "Loading..." : "See More"}
          </Button>

        </Flex>

      )}

    </div>
  );
};

export default ExploreTopMustDoThings;